import { AxiosInstance } from "axios"

export interface StripeBankAccount {
  bankName: string | null
  routingNumber: string | null
  accountNumber: string | null
  accountHolderType: string | null
  accountHolderName: string | null
  country: string | null
  currency: string | null
}

export interface StripeConnectedAccount {
  country: string
  kycDone: boolean
  accountType: string
  active: boolean
  tosAccepted: boolean
  externalAccountAdded: boolean
  pgHostAccId: number
  stripeAccountId: string
}

export interface StripeAccountData {
  email: string
  type: string
  accountHolderType: string | null
  country: string
  status: string
  bankAccount: StripeBankAccount | null
  requiredFields: string[]
  isDefault: boolean
}

export interface GetStripeAccountDetailsResponse {
  apiStatus: string
  data: {
    chargesEnabled: boolean
    connectedAccount: StripeConnectedAccount | null
    payoutsEnabled: boolean
    detailsSubmitted: boolean
    stripeAccountData: StripeAccountData | null
  }
}

export function getStripeAccountDetailsApi(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "get",
    url: "/agent/stripe/account-details",
  }) as Promise<{ data: GetStripeAccountDetailsResponse }>
}
